import { useSelector } from 'react-redux';
import { useNoticesContext } from '@srcDS/provider/notices/NoticesContext';

interface Notification {
  notificationId: string;
  type: string;
  timeout: number;
  message?: {
    props?: {
      code?: string;
      message?: string;
    };
  };
}

interface NotificationData {
  id: string;
  code?: string;
  message?: string;
  type: string;
  timeout: number;
}

interface UserState {
  notifications: {
    notifications: Record<string, Notification>;
  };
}


export const useNotifications = (): NotificationData[] => {
  const { notifications } = useSelector<{ user: UserState }, { notifications: Record<string, Notification> }>(
    (state) => state.user.notifications,
  );

  const { notices } = useNoticesContext();

  const notificationsArray: NotificationData[] = [];

  // Add context notifications if they exist
  if (notices?.type) {
    notificationsArray.push({
      id: `notice-${notices?.code || ''}`,
      code: notices?.code,
      message: notices?.message,
      type: notices.type,
      timeout: 5000,
    });
  }

  // Add Redux store notifications if they exist
  if (notifications && Object.keys(notifications).length > 0) {
    Object.values(notifications).forEach((notification) => {
      notificationsArray.push({
        id: notification.notificationId,
        code: notification?.message?.props?.code,
        message: notification?.message?.props?.message,
        type: notification.type,
        timeout: notification.timeout,
      });
    });
  }

  return notificationsArray;
};
